import React from 'react';

import LoadingButton from '../common/LoadingButton';

export default ({ fullWidth = false, size = 'large', auth, isArchiving$, onCaseAction } = {}) => {
  if (auth?.role !== 'super-admin') return null;
  return (
    <LoadingButton fullWidth={fullWidth} loading$={isArchiving$} variant="outlined" size={size} onClick={() => onCaseAction('archive')}>
      Archive
    </LoadingButton>
  );
};
